import styled from '@emotion/styled';
import { primaryFontFamily } from '../../styles/fonts';
import { responsiveContainer } from '../../styles/mixins';
import { minDeviceWidth } from '../../styles/responsive';

export const Container = styled.section`
  margin-bottom: 24px;

  @media ${minDeviceWidth('tablet')} {
    margin-bottom: 40px;
  }
`;

export const Title = styled.h1`
  ${primaryFontFamily}
  color: ${({ theme }) => theme.default.colors.n5};
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.01em;
  font-feature-settings: 'pnum' on, 'lnum' on, 'kern' off;

  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
`;

export const HeadingContainer = styled.div<{ responsiveDisabled?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-bottom: ${(props) => props.theme.spacing(4)};
  ${(props) => (props.responsiveDisabled ? '' : responsiveContainer)}
`;
